import React, { useState } from 'react'
import {
	Stepper,
	StepperHeader,
} from 'selfServicePortal/components/Stepper/stepper'
import { useStepper } from 'selfServicePortal/components/Stepper/use-stepper'
import { Screen } from 'selfServicePortal/components/ui/Screen'
import { StepTwo } from './StepTwo'
import { StepOne } from './StepOne'
import { StepThree, StepThreeStatus } from './StepThree'
import './index.scss'

export function CashToAccount() {
	const stepper = useStepper({ stepAmount: 3 })
	const [finalState, setFinalState] = useState<{
		amount: number
		referenceAccountIban: string
		referenceAccountBic?: string | undefined
	}>()
	const [stepThreeStatus, setStepThreeStatus] = useState<StepThreeStatus>()

	return (
		<Screen className="cash-to-account">
			<StepperHeader>
				<Stepper
					stepAmount={stepper.stepAmount}
					activeStep={stepper.activeStep}
				/>
			</StepperHeader>

			{stepper.activeStep === 1 && (
				<StepOne
					stepper={stepper}
					onSubmit={setFinalState}
					dirtyData={{
						amount: finalState?.amount,
						referenceAccountIban: finalState?.referenceAccountIban,
					}}
				/>
			)}
			{stepper.activeStep === 2 && finalState !== undefined && (
				<StepTwo
					stepper={stepper}
					finalState={finalState}
					onSettled={setStepThreeStatus}
				/>
			)}
			{stepper.activeStep === 3 && stepThreeStatus !== undefined && (
				<StepThree status={stepThreeStatus} />
			)}
		</Screen>
	)
}
